<template>
    <div class="feedback-step question--yes-no">
        <div class="heading-third--pink">{{ feedbackData.text }}</div>
    </div>
</template>

<script>
    export default {
        name: "StepOnlyFeedback",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            }
        },
        data() {
            return {
                yesNo: '',
                showFeedback: false,
            }
        },
        methods: {
            selectYesNo(i) {
                if (i === this.yesNo) {
                    this.yesNo = '';
                    this.$emit('updateProgress', false);
                }
                else {
                    this.yesNo = i;
                    this.$emit('updateProgress', true)
                }
            }
        },
        mounted() {
            if (this.savedAnswer) {
                this.yesNo = this.savedAnswer.value;
            }
            this.$emit('updateProgress', true);
        },
        computed: {
            questionCopy() {
                return 'question.' + this.feedbackData.id
            },
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({value: this.yesNo}),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.yesNo = this.savedAnswer.value;
                    if (this.yesNo)
                        this.$emit('showFeedback', this.yesNo)
                }
                else {
                    this.yesNo = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.yesNo = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
